export const getCroppedImg = async (imageSrc, pixelCrop, quality = 0.7, outputWidth = 1200, outputHeight = 240) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.crossOrigin = 'anonymous'; // Handle CORS if necessary

    image.onload = () => {
      try {
        // Create a canvas with the desired output dimensions
        const canvas = document.createElement('canvas');
        canvas.width = outputWidth;
        canvas.height = outputHeight;
        const ctx = canvas.getContext('2d');

        // Draw the cropped image onto the canvas, scaling it to the desired size
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          outputWidth,
          outputHeight
        );

        // Convert the canvas to a Blob
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              console.error('Canvas is empty');
              reject(new Error('Canvas is empty'));
              return;
            }
            // Create a File from the Blob
            const file = new File([blob], 'cropped.jpeg', { type: 'image/jpeg' });
            resolve(file);
          },
          'image/jpeg',
          quality // JPEG quality (0 to 1)
        );
      } catch (error) {
        console.error('Error processing image:', error);
        reject(error);
      }
    };

    image.onerror = () => {
      console.error('Failed to load image');
      reject(new Error('Failed to load image'));
    };
  });
};
